/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/092-tv': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.331 4.502a49.408 49.408 0 00-4.407-.425L13.5 1.501l-1-1L8.991 4.01A54.24 54.24 0 008 4.001l-4-4-1 1 3.034 3.034a50.304 50.304 0 00-5.365.467C.239 6.185 0 8.045 0 10s.239 3.815.669 5.498C2.913 15.821 5.393 16 8 16s5.087-.179 7.331-.502c.43-1.683.669-3.543.669-5.498s-.239-3.815-.669-5.498zm-1.833 9.164C11.815 13.881 9.955 14 8 14s-3.815-.119-5.498-.334C2.179 12.544 2 11.304 2 10s.179-2.543.502-3.666C4.185 6.119 6.045 6 8 6s3.815.119 5.498.334C13.821 7.456 14 8.696 14 10s-.179 2.543-.502 3.666z"/>'
  }
})
